import { useState } from 'react'
import { Icon } from '@iconify/react'
import clsx from 'clsx'
import { Button, Dropdown, Menu, SubMenu } from '@pepper/ui'

import PositionFilter from 'components/idea-lab/PositionFilter'
import Difficulty from './Difficulty'
import Keywords from './Keywords'
import Volume from './Volume'
import Intent from './Intent'
import Sort from './Sort'

import s from './Filter.module.css'

type Props = {
  isSuggested?: boolean
}

const menu = (handleChange: () => void, isSuggested?: boolean): JSX.Element => {
  return (
    <Menu
      className={clsx(s.menu, {
        [s.menuSuggestions]: isSuggested,
      })}
    >
      <SubMenu
        title={
          isSuggested ? (
            <div className={s.title}>
              <Icon icon="lucide:arrow-left" />
              Keyword contains
            </div>
          ) : (
            'Keyword contains'
          )
        }
        popupClassName={s.subMenu}
      >
        <Keywords onChange={handleChange} />
      </SubMenu>
      <SubMenu
        title={
          isSuggested ? (
            <div className={s.title}>
              <Icon icon="lucide:arrow-left" />
              Difficulty
            </div>
          ) : (
            'Difficulty'
          )
        }
        popupClassName={s.subMenu}
      >
        <Difficulty onChange={handleChange} />
      </SubMenu>
      <SubMenu
        title={
          isSuggested ? (
            <div className={s.title}>
              <Icon icon="lucide:arrow-left" />
              Volume
            </div>
          ) : (
            'Volume'
          )
        }
        popupClassName={s.subMenu}
      >
        <Volume onChange={handleChange} />
      </SubMenu>
      <SubMenu
        title={
          isSuggested ? (
            <div className={s.title}>
              <Icon icon="lucide:arrow-left" />
              Exclude Positions
            </div>
          ) : (
            'Exclude Positions'
          )
        }
        popupClassName={s.subMenu}
      >
        <PositionFilter />
      </SubMenu>
      {!isSuggested && (
        <SubMenu title="Intent" popupClassName={s.subMenu}>
          <Intent onChange={handleChange} />
        </SubMenu>
      )}
    </Menu>
  )
}

export const Filter = ({ isSuggested }: Props) => {
  const [isFilterVisible, setIsFilterVisible] = useState(false)
  const [isSortVisible, setIsSortVisible] = useState(false)

  const handleChange = () => {
    setIsFilterVisible(false)
  }

  return (
    <div className={s.wrapper}>
      <div className={s.filterWrapper}>
        <Dropdown
          overlay={() => menu(handleChange, isSuggested)}
          trigger={['click']}
          onVisibleChange={visible => setIsFilterVisible(visible)}
        >
          {isSuggested ? (
            <div
              role="none"
              className={clsx(s.trigger, {
                [s.active]: isFilterVisible,
              })}
            >
              <Icon icon="lucide:filter" width={16} height={16} />
            </div>
          ) : (
            <button className={s.filterTrigger}>
              Filters
              <Icon icon="lucide:chevron-down" />
            </button>
          )}
        </Dropdown>
      </div>
      <div className={s.actionsWrapper}>
        <Dropdown
          overlay={<Sort />}
          trigger={['click']}
          onVisibleChange={visible => setIsSortVisible(visible)}
        >
          {isSuggested ? (
            <div
              role="none"
              className={clsx(s.trigger, {
                [s.active]: isSortVisible,
              })}
            >
              <Icon icon="uil:sort-amount-up" width={18} height={18} />
            </div>
          ) : (
            <Button
              type="default"
              icon={<Icon icon="uil:sort-amount-up" width={18} height={18} />}
              iconPlacement="left"
            >
              Sort
            </Button>
          )}
        </Dropdown>
      </div>
    </div>
  )
}
